import React, { useCallback, useState } from 'react';
import { Menu, Popover } from '@arco-design/web-react';
import { ToolItem } from '../ToolItem';
import { t } from '@bay-email/core';
import styleText from '../../styles/ToolsPopover.css?inline';

const list = [
	{
		value: 'initial',
		label: t('None'),
	},
	{
		value: 'uppercase',
		label: 'ABC',
	},
	{
		value: 'lowercase',
		label: 'abc',
	},
	{
		value: 'capitalize',
		label: 'Abc',
	},
];

export interface TextTransformProps {
	execCommand: (cmd: string, value: any) => void;
	getPopupContainer: () => HTMLElement;
	onBeforeInteract?: () => void;
}

export function TextTransform(props: TextTransformProps) {
	const { execCommand } = props;
	const [visible, setVisible] = useState(false);

	const onChange = useCallback(
		(val: string) => {
			props.onBeforeInteract?.();
			execCommand('textTransform', val);
			setVisible(false);
		},
		[execCommand, props],
	);

	return (
		<Popover
			trigger='click'
			color='#fff'
			position='bl'
			className='bay-email-extensions-Tools-Popover'
			popupVisible={visible}
			onVisibleChange={nextVisible => {
				if (nextVisible) {
					props.onBeforeInteract?.();
				}
				setVisible(nextVisible);
			}}
			content={
				<>
					<style>{styleText}</style>
					<div
						onMouseDownCapture={() => props.onBeforeInteract?.()}
						style={{
							maxWidth: 150,
							maxHeight: 300,
							overflowY: 'auto',
							overflowX: 'hidden',
						}}
					>
						<Menu
							onClickMenuItem={onChange}
							selectedKeys={[]}
							style={{ border: 'none', padding: 0 }}
						>
							{list.map(item => (
								<Menu.Item
									style={{ lineHeight: '30px', height: 30 }}
									key={item.value}
								>
									{item.label}
								</Menu.Item>
							))}
						</Menu>
					</div>
				</>
			}
			getPopupContainer={props.getPopupContainer}
		>
			<ToolItem
				title={t('Text Transform')}
				icon={<span style={{ fontWeight: 600, fontSize: 12 }}>Aa</span>}
			/>
		</Popover>
	);
}
